import { ReviewEntryDetailPresenter } from '@/presentation/presenters/review/reviewEntryDetailPresenter'
import { ReviewEntryDetailViewModel } from '@/presentation/viewmodels/review/reviewEntryDetailViewModel'

export function useReviewEntryDetailPresenter(
  presenter: ReviewEntryDetailPresenter = new ReviewEntryDetailPresenter(new ReviewEntryDetailViewModel())
) {
  return {
    reviewEntryDetailList: presenter.reviewEntryDetailList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    fetchReviewEntryDetailList: presenter.fetchReviewEntryDetailList.bind(presenter),
    hasEntryDetailInList: presenter.hasEntryDetailInList.bind(presenter)
  }
}
